<template>
    <div class="nav-wrapper" :class="'nav-wrapper--'+colorClass">
        <div class="container">
            <div class="columns">
                <div class="column">
                    <div class="navbar" role="navigation" aria-label="main navigation">
                        <div class="navbar-brand">
                            <router-link class="navbar-item" to="/">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140 90.7">
                                  <path fill="#fff" d="M35 51H7.4a4.8 4.8 0 0 0-4.8 4.8v27.1c0 2.6 2.2 4.8 4.8 4.8h27.3c2.6 0 4.8-2.2 4.8-4.8V55.8c.1-2.6-2.2-4.8-4.8-4.8zm47 .6H56.8c-2.4 0-4.4 2-4.4 4.6v26.3c0 2.5 2 4.6 4.4 4.6H82c2.4 0 4.4-2 4.4-4.6V56.2c.1-2.5-2-4.6-4.4-4.6zM34.2 4.9H8.4C5.9 4.9 3.9 6.8 3.9 9v24.3c0 2.3 2 4.2 4.5 4.2H34c2.5 0 4.5-1.9 4.5-4.2V9c0-2.3-2-4.2-4.5-4.2z"/>
                                  <path fill="#ef3fa9" d="M37.1 0H5.5C2.5 0 0 2.5 0 5.5V37c0 3 2.5 5.5 5.5 5.5H37c3 0 5.5-2.5 5.5-5.5V5.5C42.6 2.5 40 0 37 0zM25.6 31.6H13.1a1.6 1.6 0 0 1 0-3.3h12.5a2.7 2.7 0 0 0 0-5.4H17A6 6 0 0 1 17 11h12.4a1.6 1.6 0 0 1 0 3.3H17a2.7 2.7 0 0 0 0 5.4h8.6a6 6 0 0 1 0 11.9z"/>
                                  <path class="logo-description" fill="#1b2d70" d="M100.1 27h.8v6.3h-.8zm18.9 1.5c0-.7.6-1 1.3-1 .6 0 1.3.3 1.5 1l.7-.5c-.3-.8-1.1-1.3-2.2-1.3-1.3 0-2.2.8-2.2 1.8 0 2.4 3.7 1.5 3.7 3 0 .8-.7 1-1.4 1-.9 0-1.5-.4-1.8-1l-.7.4c.3.8 1.2 1.5 2.5 1.5s2.3-.8 2.3-1.9c0-2.3-3.7-1.4-3.7-3zm-18.5-4.2a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2zm-3.9.7l-.8.3V27h-1.4v.8h1.4v3.8c0 1.6 1 2 2.7 1.7v-.7c-1.3 0-1.9.1-1.9-1v-3.8h1.9V27h-1.9zm17.4 1.7c-1 0-1.7.4-2.2 1.2v-1h-.8v6.3h.8V30c0-1.7 1-2.4 2-2.4 1.2 0 1.8.7 1.8 1.8v4h.8v-4c0-1.6-1-2.6-2.5-2.6zm-8 0a3.3 3.3 0 0 0-3.4 3.3 3.4 3.4 0 1 0 3.4-3.3zm0 5.9a2.5 2.5 0 0 1-2.6-2.6c0-1.4 1.1-2.5 2.6-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.5-1.1 2.6-2.5 2.6zM84.8 24h.8v9.2h-.8zm-5 2.7a3.3 3.3 0 0 0-3.3 3.3c0 2 1.5 3.4 3.3 3.4a3.4 3.4 0 0 0 0-6.7zm0 5.9a2.5 2.5 0 0 1-2.5-2.6c0-1.4 1.1-2.5 2.5-2.5 1.5 0 2.6 1.1 2.6 2.5 0 1.5-1.1 2.6-2.6 2.6zm-7.7-.1c-1.4 0-2.2-.7-2.5-1.7l-.8.4c.4 1.4 1.7 2.2 3.3 2.2 1.8 0 3-1 3-2.5 0-1.7-1.4-2.1-3-2.7-1.3-.4-2-.7-2-1.6 0-1 .7-1.6 1.8-1.6 1.2 0 1.9.7 2.2 1.5l.7-.4c-.4-1-1.4-2-2.9-2s-2.7 1-2.7 2.5c0 1.7 1.4 2 2.8 2.5 1.3.5 2.2.8 2.2 1.8s-.7 1.6-2 1.6zm20.1-2.3c0 1.7-1 2.4-2 2.4-1.2 0-1.8-.7-1.8-1.8v-4h-.8v4c0 1.6 1 2.6 2.5 2.6.9 0 1.6-.4 2.1-1.2v1h.8V27h-.8zm30-21a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2zm-18.1 3.2c1 0 1.6.6 1.6 1.8v4h.8v-4c0-1.6-1-2.6-2.3-2.6-.9 0-1.6.4-2.1 1.2a2 2 0 0 0-2-1.2c-.7 0-1.4.3-1.9 1.1v-1h-.8v6.4h.8v-3.5c0-1.6 1-2.2 1.8-2.2 1 0 1.5.6 1.5 1.8v4h.9v-3.6c0-1.6.8-2.2 1.7-2.2zm23.5 5.1a2.5 2.5 0 0 1-2.5-2.5c0-1.5 1.1-2.6 2.5-2.6 1 0 1.8.5 2.1 1.3l.7-.4a3 3 0 0 0-2.8-1.7 3.3 3.3 0 0 0-3.3 3.4c0 1.8 1.4 3.3 3.3 3.3 1.3 0 2.4-.7 2.9-1.7l-.7-.4c-.4.8-1.2 1.3-2.2 1.3zm-33.1-5.7V13a3 3 0 0 0-2.6-1.4 3.3 3.3 0 0 0-3.3 3.4c0 1.8 1.5 3.3 3.3 3.3a3 3 0 0 0 2.6-1.4v1c0 1.3-.9 2.1-2.4 2.1-1.3 0-2-.5-2.2-1.1l-.8.4c.5 1 1.6 1.5 3 1.5 1.7 0 3.2-1 3.2-3v-6h-.8zM92 17.5a2.5 2.5 0 0 1-2.5-2.5c0-1.5 1-2.6 2.5-2.6 1.4 0 2.5 1.1 2.5 2.6 0 1.4-1.1 2.5-2.5 2.5zM72.5 9.2h-3.2v9h.9v-3.4h2.3c1.6 0 2.8-1.2 2.8-2.8 0-1.6-1.2-2.8-2.8-2.8zm0 4.8h-2.3v-4h2.3c1 0 1.9.9 1.9 2 0 1.2-.8 2-2 2zm49.3-2.2h.8v6.4h-.8zm-35.7 0V13a3 3 0 0 0-2.5-1.4 3.3 3.3 0 0 0-3.3 3.4c0 1.8 1.5 3.3 3.3 3.3a3 3 0 0 0 2.5-1.4V18h.9v-6.3h-1zm-2.5 5.7a2.5 2.5 0 0 1-2.5-2.5c0-1.5 1.1-2.6 2.5-2.6 1.5 0 2.5 1.1 2.5 2.6 0 1.4-1 2.5-2.5 2.5zm-6-2.9c0-1.6 1-2.1 2-2.1v-.8c-.8 0-1.5.2-2 1.1v-1h-.8V18h.8zm42.5 3.5v-.7c-1.2 0-1.8.1-1.8-1v-3.8h1.8v-.8h-1.8V10l-.8.2v1.6H116v.8h1.4v3.8c0 1.6 1 2 2.6 1.7zm-6.2-6.3V13a3 3 0 0 0-2.6-1.4A3.3 3.3 0 0 0 108 15c0 1.8 1.5 3.3 3.3 3.3a3 3 0 0 0 2.6-1.4V18h.8v-6.3h-.8zm-2.5 5.7a2.5 2.5 0 0 1-2.5-2.5c0-1.5 1-2.6 2.5-2.6 1.4 0 2.5 1.1 2.5 2.6 0 1.4-1.1 2.5-2.5 2.5z"/>
                                  <path fill="#00a0df" d="M85.2 48.1H53.6c-3 0-5.5 2.5-5.5 5.5v31.6c0 3 2.5 5.5 5.5 5.5h31.6c3 0 5.5-2.4 5.5-5.5V53.6c0-3-2.4-5.5-5.5-5.5zm-5.5 25.5a6 6 0 0 1-10.3 4.1 6 6 0 0 1-10.3-4.1V60.9a1.6 1.6 0 0 1 3.3 0v12.7a2.7 2.7 0 0 0 5.4 0V60.9a1.6 1.6 0 1 1 3.3 0v12.7a2.7 2.7 0 0 0 5.4 0V60.9a1.6 1.6 0 1 1 3.2 0z"/>
                                  <path fill="#1b2d70" d="M37.1 48.1H5.5c-3 0-5.5 2.5-5.5 5.5v31.6c0 3 2.5 5.5 5.5 5.5H37c3 0 5.5-2.4 5.5-5.5V53.6c0-3-2.5-5.5-5.5-5.5zM25.6 79.7H13.1a1.6 1.6 0 0 1 0-3.3h12.5a2.7 2.7 0 0 0 0-5.3H17a6 6 0 0 1 0-12h12.4a1.6 1.6 0 0 1 0 3.3H17a2.7 2.7 0 0 0 0 5.4h8.6a6 6 0 0 1 0 11.9z"/>
                                </svg>
                            </router-link>
                            <a role="button" class="navbar-burger" :class="{'is-active':burger}" aria-label="menu" aria-expanded="false" @click="burger = !burger">
                                <span aria-hidden="true"></span>
                                <span aria-hidden="true"></span>
                                <span aria-hidden="true"></span>
                            </a>
                        </div>
                        <div class="navbar-menu" :class="{'is-active':burger}">
                            <div class="navbar-end" @click="burger = false">
                                <slot></slot>
                                <div class="navbar-item has-dropdown is-hoverable navbar-lang">
                                    <a class="navbar-link" href="#" @click.prevent>
                                        {{ $i18n.locale }}
                                    </a>
                                    <div class="navbar-dropdown is-boxed">
                                        <a
                                            class="navbar-item is-active"
                                            :href="langUrl(lang)"
                                            v-for="(lang, i) in langs"
                                            :key="`Lang${i}`"
                                            v-if="lang != $i18n.locale"
                                        >
                                            {{ lang }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defaultLocale } from '../lang.js'
import { locale } from '../lang.js'
import { langs } from '../lang.js'
import { eventBus } from '../event-bus.js'
export default {
    data(){
        return{
            burger: false,
            colorClass: 'default',
            langs,
            defaultLocale
        }
    },
    watch: {
        $route (to, from){
            this.burger = false
        }
    },
    methods: {
        langUrl(lang){
            const publicPath = (process.env.VUE_APP_PUBLIC_PATH === undefined || process.env.VUE_APP_PUBLIC_PATH === null) ? '/' : process.env.VUE_APP_PUBLIC_PATH
            let base = publicPath //window.location.origin + publicPath
            base = (lang != this.defaultLocale) ? base+lang+'/' : base
            return base
        }
    },
    mounted(){
        eventBus.$on('change-color',(color) => {
            this.colorClass = color;
        })
    },
}
</script>

<style scoped lang="sass">
@import "@/styles/framework/variables.sass"
@import "@/styles/framework/extends.sass"
.nav-wrapper
    position: fixed
    top: 0
    left: 0
    right: 0
    z-index: 30
    width: 100%
    max-width: none
    background-color: $white
    transform: translate(0)
    box-shadow: 0 5px 5px $grey1
    .navbar-brand
        a
            @extend %button-reset
            svg
                padding-right: 3rem
                height: 3rem
                +touch
                    padding-left: 1rem
                    padding-right: 0
                +desktop
                    border-right: 1px solid $grey1
    .navbar-lang
        text-transform: uppercase
    .navbar-end
        .navbar-item
            +desktop
                padding: 0 2rem
            a
                font-weight: bold
                color: $blue1
                transition: color $fast
                &:hover
                    color: $pink
</style>
